export { menuVariables as menuItemIndicatorVariables } from './menuVariables';
